import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from '@carvana/showroom-spinner';
import BackLink from '../future-packages/back-link';
import ConnectBankCard from './ConnectBankCard';
import MyCarsRefreshHook from '../../utils/MyCarsRefreshHook';
import { useDualEventTracking } from '../../utils/useDualEventTracking';
import {
  MyCarsContentWrapper,
  ConnectBankWrapper,
  SpinnerWrapper,
} from './ConnectBank.styles';

const ConnectBank = () => {
  const { id: vehicleId }: any = useParams();
  const { trackEvent } = useDualEventTracking();
  useEffect(() => {
    trackEvent('BankInfo Screen');
    window.scrollTo(0, 0);
  }, []);

  // Refresh Hook - Avoid selectors/ redux state access before the refresh hook and loader
  const isLoading = MyCarsRefreshHook(vehicleId);
  if (isLoading) {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
  }

  return (
    <ConnectBankWrapper>
      <MyCarsContentWrapper>
        <BackLink
          backLinkTrackEvent="bank_info_navigate_back_to_loan_details"
          backLinkText="Back to Loan Details"
          backLinkRoute={`/loan-detail/${vehicleId}`}
        />
        <ConnectBankCard vehicleId={vehicleId} />
      </MyCarsContentWrapper>
    </ConnectBankWrapper>
  );
};

export default ConnectBank;
